/**
 * Module parameter
 *
 * This module handle the display of parameters
 *
 */

'use strict';

const _ = require('lodash');

const Mediator = require('./../../../core/mediator');
const Container = require('./../../../core/container');
const PopinManager = require('./../../../services/popin');
const FormBuilder = require('./../../../services/form');
const Translator = require('./../../../core/translator');
const SaveManager = require('./../component/SaveManager');
const ContentManager = require('./../component/ContentManager');
const DndZone = require('./../service/dndZone');
const ResizeColumn = require('./../service/resizeColumn');
const Help = require('./../../../services/help');
const Plugin = require('./index');

module.exports.showForm = function(object, extraPopinConfig = {}) {
    Mediator.publish('before:show:parameters', object);

    if (object.alreadyUsed) {
        return;
    }

    let content = object;

    let form;
    let popinConfig = {
        'title': Translator.translate('title_parameters') + ' ' + Translator.translate(content.getLabel()),
        'position': {my: 'center top', at: 'center top+50', of: window},
        'width': content.definition.properties['form_width'] || 460,
        'height': content.definition.properties['form_height'] || 'auto',
        'maxHeight': window.outerHeight - 200,
        'buttons': [
            {
                class: 'popin popin-cancel',
                text: Translator.translate(object.discardText ? object.discardText : 'discard'),
                click: function() {
                    form.dispatch('cancel');
                    popin.hide();
                },
            },
            {
                class: 'popin popin-ok',
                text: Translator.translate(object.submitText ? object.submitText : 'submit'),
                click: function() {
                    if (!form.$.hasClass('prevent-submit')) {
                        form.submit();
                    }
                },
            },
        ],
    };
    let popin = PopinManager.createPopin(Object.assign(popinConfig, extraPopinConfig));

    Plugin.onClick(content, true);

    content.getData().done(function() {
        let config = {
            'form': {
                'submit_class': 'd-none',
            },
        };

        config.elements = {};

        _.forEach(content.data.parameters, function(value, key) {
            if (_.isString(value.type)) {
                config.elements[key] = value;
            }
        });

        config.parentElement = content;
        Mediator.publish('before:form-parameters:build', config);

        form = FormBuilder.getForm(config);

        form.listeners.cancel = [];
        form.listeners['submit.parameters'] = [];

        form.content = content;

        form.on('submit', function(data) {
            form.dispatch('submit.parameters');

            if (!_.isEmpty(data)) {
                content.setParameters(data);
            }

            SaveManager.save().done(function() {
                content.refresh().done(function() {
                    ContentManager.refreshResizeImage();
                    DndZone.apply();
                    ResizeColumn.apply();
                    popin.hide();

                    Mediator.publish('after:' + content.type + ':submit:parameters', content);
                    Mediator.publish('after:submit:parameters', content);
                });
            });
        });

        popin.setContent(form.render());

        popin.display();

        Mediator.publish(`after:parameters:shown`, {
            'content': content,
            'popin': popin,
        });

        if (content.preventOverlay === true) {
            popin.on('close', function() {
                setTimeout(function() {
                    Container.set('prevent-hide-overlay', false);
                    content.preventOverlay = false;
                }, 100);
            });
            Container.set('prevent-hide-overlay', true);
        }

        form.$.find('input[type=text]:not(.no-autofocus):first').focus();
    });

    return {
        popin,
    };
};

module.exports.afterParametersShown = function(config) {
    let content = config.content;
    let popin = config.popin;
    let $link = Help.createLink(`content_${content.type}`);
    let $title = popin.rootElement.parent().find('.ui-dialog-titlebar:first').find('.ui-dialog-title:first');

    $link.addClass('popin');

    $title.append($link);
};
